import { Text, View } from 'native-base'

import { AddressAttribute, Order, OrderServiceType } from '@consumer/graphql'
import { Badge } from '@consumer/ui'

import { fonts } from '../../../utils/theme/configureTheme'

// The deleted InstructionsBadge rendered through native-base's `bodyBold`
// font token; CWA's Matter faces are registered per-weight, so the family
// must be restated here (the shared Badge is font-agnostic until CBP-3947).
const compactBadgeTextStyle = { fontFamily: fonts.bodyBold }

export interface InstructionsRenderProps {
  order: Order
}

export const InstructionsRender = ({ order }: InstructionsRenderProps) => {
  let typeLabel, locationLabel, preferredLocation, instructions
  if (order?.serviceType === OrderServiceType.Pickup) {
    typeLabel = 'Pickup from my '
    locationLabel = 'Collect from '
    preferredLocation = order.address.preferredPickupLocation
    instructions = order.address.pickupInstructions
  } else {
    typeLabel = 'Deliver to my '
    preferredLocation = order.address.preferredLocation
    locationLabel = preferredLocation === 'Property Staff' ? 'Leave with ' : 'Leave at '
    instructions = order.address.instructions
  }

  const hasDog = !!order.address.attributes?.find(attr => attr === AddressAttribute.HasDog)
  const showInstructionsPrefixText = !!(
    !!order.address.type ||
    (!!order.address.preferredLocation && preferredLocation !== 'Not Set') ||
    !!order.address.securityCode
  )

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        rowGap: 4,
        columnGap: 1,
        alignItems: 'baseline',
        flexWrap: 'wrap',
      }}
    >
      <Text fontSize={12} lineHeight={24} flexWrap={'wrap'}>
        {!!order.address.type && (
          <>
            {typeLabel}
            <Badge variant="compact" textStyle={compactBadgeTextStyle} label={order.address.type} />
            {'. '}
          </>
        )}

        {!!preferredLocation && preferredLocation !== 'Not Set' && (
          <>
            {locationLabel}
            <Badge variant="compact" textStyle={compactBadgeTextStyle} label={preferredLocation} />
            {'. '}
          </>
        )}
        {!!order.address.securityCode && (
          <>
            {'My access code is '}
            <Badge variant="compact" textStyle={compactBadgeTextStyle} label={order.address.securityCode} />
            {'. '}
          </>
        )}
        {!!instructions && (
          <>
            {showInstructionsPrefixText ? 'And ' : ''}
            <Badge variant="compact" textStyle={compactBadgeTextStyle} label={instructions} />
          </>
        )}
        {hasDog && <Badge variant="compact" textStyle={compactBadgeTextStyle} label={'Beware of dog'} />}
      </Text>
    </View>
  )
}
